import {initialTopPanelState, ITopPanelState} from "../../state/top-panel/top-panel.state";
import {ETopPanelActions, TopPanelActions} from "../../actions/top-panel/top-panel.actions";

export const topPanelReducers = (
  state = initialTopPanelState,
  action: TopPanelActions
):ITopPanelState =>{
  switch (action.type) {
    case ETopPanelActions.ClearParameters:

      return {
        ...state,
        parametersValues:[],
      };
    case ETopPanelActions.SetParameter:
      const tmp = state.parametersValues.find(t=>t.name === action.payload.name);
      if (tmp) {
        tmp.value = action.payload.value;
      }else {
        state.parametersValues.push(action.payload);
      }
      return {...state };

    case ETopPanelActions.RemoveParameter:
      return {
        ...state,
        parametersValues: state.parametersValues.filter(t=>t.name !==action.payload)
      };

    case ETopPanelActions.SetQueryParameters:
      return {
        ...state,
        queryParameters: action.payload

      };
    default:
      return state;
  }
};
